// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-29T17:36:34.289Z
// Property: The 101 (ID: 6767906449164270)
// Collections: 25 amenities, 26 floorplans (live), 24 photos, 31 POIs, 2 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162415",
  "multihub_property_id": "6767906449164270",
  "property_external_id": "77603",
  "property_zillow_url": "https://www.zillow.com/apartments/kirkland-wa/the-101/5XjxYv/",
  "property_apartments_url": "https://www.apartments.com/11-main-st-s-kirkland-wa-unit-315950093/gwwx9fz/",
  "property_google_business_url": "https://www.google.com/maps?cid=10883407230815941004",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-101",
  "property_name": "The 101",
  "property_website_url": "https://www.the101kirkland.com",
  "property_domain": "https://www.the101kirkland.com",
  "property_address": "11 Main St. S.",
  "property_full_address": "11 Main St S, Kirkland, WA 98033",
  "property_address_1": "11 Main St S",
  "property_address_2": null,
  "property_address_city": "Kirkland",
  "property_address_state": "WA",
  "property_address_zip_full": null,
  "property_address_zip": "98033",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Moss Bay",
  "property_address_latitude": "47.6753491",
  "property_address_longitude": "-122.2057658",
  "property_email": "leasing@the101kirkland.com",
  "property_phone": "(844) 891-3356",
  "property_call_tracking_phone": "844-894-0442",
  "property_company_name": "Pillar Properties",
  "property_company_url": "https://www.pillarproperties.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Experience urban living at The 101 in Kirkland, WA, where high-end finishes meet unmatched amenities. Relax on the rooftop deck overlooking Lake Washington and the Seattle skyline, or enjoy onsite dining just steps away. Choose from studio to two-bedroom layouts designed for comfort and style. Your new home awaits!",
  "property_long_description": "This is your opportunity to live, work and play, in the heart of it all. Located at the intersection of Lake Street and Kirkland Avenue, The 101 is a boutique apartment community as prominent as its location. Take advantage of all downtown Kirkland has to offer simply by walking out your door, or kick back and relax in your new home and enjoy spectacular views of Lake Washington and the Seattle skyline. The 101 is a 66-unit boutique apartment community comprised of uniquely designed Studio, One and Two bedroom units that provide the perfect answers to your living needs. The spacious homes feature high end finishes, private decks, air conditioning and an expansive roof top deck.  Here you will find distinctive architectural design features and an unparalleled sense of community.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-75e4-77aa-9604-813db3635dbe.webp",
  "property_featured_image_media": {
    "alt_text": "Rooftop terrace with lounge chairs, dining tables, umbrellas, and grills.",
    "public_id": "019d20ac-75e4-77aa-9604-813db3635dbe",
    "storage_key": "property/6767906449164270/019d20ac-75e4-77aa-9604-813db3635dbe.webp",
    "width": 3072,
    "height": 1726
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "66",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": "96",
  "property_transit_score": "49",
  "property_business_hours_list": null,
  "property_current_occupancy": "87.87878787878788",
  "property_admin_fee": "300",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "180",
  "property_pet_restrictions": "Questions about breed restrictions will be answered by property team.",
  "property_pet_policy_description": "Pet Types Allowed: Dogs and Cats\nMax Pets: 2\nMonthly Pet Rent: $50/ Month per pet\nPet rent applies per pet\nPet Deposit: $300\nNon-Refundable One-Time Pet Fee: $300",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://the101kirkland.securecafe.com/onlineleasing/the-101/floorplans.aspx",
  "property_resident_portal_url": "https://the101kirkland.securecafenet.com/residentservices/the-101/userlogin",
  "property_apply_now_url": "https://the101kirkland.securecafe.com/onlineleasing/the-101/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0815-0ce4-7549-9417-d2ae31a90262.webp",
  "property_primary_logo_media": {
    "alt_text": "The 101 logo",
    "public_id": "019d0815-0ce4-7549-9417-d2ae31a90262",
    "storage_key": "property/6767906449164270/019d0815-0ce4-7549-9417-d2ae31a90262.webp",
    "width": 150,
    "height": 181
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0815-14bb-7779-9f11-a4ee5f24290b.webp",
  "property_secondary_logo_media": {
    "alt_text": "The 101 logo",
    "public_id": "019d0815-14bb-7779-9f11-a4ee5f24290b",
    "storage_key": "property/6767906449164270/019d0815-14bb-7779-9f11-a4ee5f24290b.webp",
    "width": 354,
    "height": 528
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0815-26f8-74da-957d-fa6a7c4b9e97.webp",
  "property_icon_media": {
    "alt_text": "101 The Apartment Community logo",
    "public_id": "019d0815-26f8-74da-957d-fa6a7c4b9e97",
    "storage_key": "property/6767906449164270/019d0815-26f8-74da-957d-fa6a7c4b9e97.webp",
    "width": 29,
    "height": 43
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0815-26f8-74da-957d-fa6a7c4b9e97.webp",
  "property_fav_icon_media": {
    "alt_text": "101 The Apartment Community logo",
    "public_id": "019d0815-26f8-74da-957d-fa6a7c4b9e97",
    "storage_key": "property/6767906449164270/019d0815-26f8-74da-957d-fa6a7c4b9e97.webp",
    "width": 29,
    "height": 43
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0815-14bb-7779-9f11-a4ee5f24290b.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The 101 logo",
    "public_id": "019d0815-14bb-7779-9f11-a4ee5f24290b",
    "storage_key": "property/6767906449164270/019d0815-14bb-7779-9f11-a4ee5f24290b.webp",
    "width": 354,
    "height": 528
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0815-1e5d-70eb-91f1-4be3a045dc13.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The 101 logo",
    "public_id": "019d0815-1e5d-70eb-91f1-4be3a045dc13",
    "storage_key": "property/6767906449164270/019d0815-1e5d-70eb-91f1-4be3a045dc13.webp",
    "width": 354,
    "height": 528
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d06cf-26f9-7551-948c-1245b11c8422.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
  "property_company_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc2-1eb8-7554-8d89-d3424651cf63",
    "storage_key": "company/5767906449162415/019d2fc2-1eb8-7554-8d89-d3424651cf63.webp",
    "width": 189,
    "height": 128
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-9029-7028-b531-c3ae9dacde22",
    "storage_key": "company/5767906449162415/019d2fc1-9029-7028-b531-c3ae9dacde22.webp",
    "width": 178,
    "height": 122
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Pillar Properties logo",
    "public_id": "019d2fc1-00d2-7093-a184-b3de0f0bba5a",
    "storage_key": "company/5767906449162415/019d2fc1-00d2-7093-a184-b3de0f0bba5a.webp",
    "width": 178,
    "height": 122
  },
  "property_primary_color": "#6f878d",
  "property_secondary_color": "#000000",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "576 - 1136",
  "property_sqft_min": "576",
  "property_sqft_max": "1136",
  "property_price_range": "2169 - 4891",
  "property_price_min": "2169",
  "property_price_max": "4891",
  "property_available_units": 3,
  "property_facebook_url": "https://www.facebook.com/The101Kirkland/",
  "property_instagram_url": "https://www.instagram.com/the101kirkland",
  "property_twitter_url": "https://x.com/The101Kirkland",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJLzcdf90SkFQRjLGzsjahCZc",
  "property_youtube_url": "https://www.youtube.com/watch?v=-lujJU8kMvs&t=53",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Kirkland%2C+WA",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The 101",
  "property_home_romance_title": "Welcome to The 101",
  "property_home_amenities_blurb": "Welcome to The 101 in Kirkland, WA, where modern elegance meets urban lifestyle. Choose from our stylish studios, one-bedroom, or two-bedroom apartments with high-end finishes. Enjoy breathtaking views from our rooftop deck, unwind by the fire pits, or grab a bite just steps away—all within two blocks of Lake Washington. ",
  "property_home_floorplans_blurb": "At The 101 in Kirkland, WA, each floor plan, from cozy studios to spacious two-bedrooms, offers a unique living experience tailored to your lifestyle. Step into a world of comfort and style—browse our available apartment homes today and uncover the perfect layout that speaks to you!",
  "property_home_gallery_blurb": "Welcome to The 101, where chic Kirkland living meets stunning views. Choose from stylish studio to spacious two-bedroom floor plans, all featuring high-end finishes. Unwind on our rooftop deck or enjoy onsite dining and relaxation just steps from Lake Washington. Picture yourself living here—your urban oasis awaits!",
  "property_home_neighborhood_blurb": "At The 101 in Kirkland, WA, vibrant living meets an abundance of experiences. Revel in the charm of local gems like the expansive Bellevue Downtown Park, the dynamic University of Washington Bothell, and enriching cultural spots like the Burke Museum. Discover your perfect floor plan and embrace community connections!",
  "property_home_reviews_blurb": "At The 101 in Kirkland, residents rave about “a good experience” living in a well-maintained community with a supportive management team. Enjoy breathtaking views from the rooftop terrace and vibrant social events that foster friendships. With countless amenities and a prime location, your perfect apartment awaits!",
  "property_neighborhood_blurb": "At The 101 in Kirkland, vibrant living meets endless possibilities. Step outside to explore cultural treasures like the Burke Museum and Seattle Asian Art Museum, or enjoy nature at Marymoor Park and Bellevue Downtown Park. Our community places you close to the University of Washington, enriching your everyday experience. See what's around our community!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At The 101 in Kirkland, indulge in modern living with high-end finishes and breathtaking views of Lake Washington and the Seattle skyline from our rooftop deck. Enjoy the convenience of onsite amenities, including grilling areas, package lockers, and a vibrant downtown right at your doorstep. Your ideal lifestyle awaits!",
  "property_applynow_blurb": "At The 101 in vibrant Kirkland, WA, experience modern living with stylish studio, one, and two-bedroom floor plans that elevate your lifestyle. Unwind on our rooftop deck with stunning lake and skyline vistas, or enjoy first-class amenities like high-end finishes, convenient onsite dining, and air-conditioned comfort. Find your new home and lease online today!",
  "property_contactus_blurb": "At The 101 in picturesque Kirkland, WA, we proudly offer a range of stylish floor plans, from cozy studios to spacious two-bedroom apartments. Whether you're seeking simplicity or room for your lifestyle, our team is here to assist you. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "At The 101 in Kirkland, WA, our diverse floor plans—studio, one-bedroom, and two-bedroom—cater to your lifestyle. Have questions? Dive into our FAQs page for insightful answers about our vibrant community and discover how The 101 can be your perfect home sweet home!",
  "property_floorplans_blurb": "At The 101 in Kirkland, WA, versatile living awaits you! Choose from sleek studios, stylish one-bedroom, or spacious two-bedroom apartments tailored to fit your lifestyle. Each unique floor plan combines comfort and modern elegance. Browse our available apartment homes today and uncover the ideal space for your next adventure!",
  "property_gallery_blurb": "At The 101 in downtown Kirkland, your dream lifestyle awaits. Picture yourself soaking in breathtaking views of Lake Washington and the Seattle skyline from our rooftop deck, or enjoying high-end finishes in our stylish apartments. With conveniences just steps away, your perfect home is closer than you think!",
  "property_interactivemap_blurb": "At The 101 in vibrant Kirkland, WA, indulge in upscale living with stunning views of Lake Washington and the Seattle skyline from our rooftop deck. Choose from stylish studios, one and two-bedroom apartments equipped with high-end finishes. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At The 101 in Kirkland, WA, your furry friends are cherished as part of the family! Our pet-friendly community opens its doors to well-behaved dogs and cats, inviting you to enjoy spacious living alongside your pets. Experience comfort and companionship in a place where every tail can wag with joy!",
  "property_referafriend_blurb": "At The 101 in Kirkland, WA, your next home awaits! Whether you're seeking a cozy studio, a spacious one-bedroom, or a two-bedroom haven, we offer floor plans tailored to your lifestyle. Great friends make great neighbors—refer a friend to join our vibrant community today!",
  "property_residentaccess_blurb": "Welcome to The 101, Kirkland, WA's premier apartment community. Choose from stylish studio, one-bedroom, and two-bedroom floor plans designed for modern living. Enhance your experience by accessing our resident portal—easy rent payments, maintenance requests, and essential updates are just a click away! Join us in redefining home convenience.",
  "property_reviews_blurb": "At The 101 in Kirkland, residents rave about our community's vibrant atmosphere and stunning rooftop views. \"Dee loves her job and her tenants,\" making every effort to create connections through monthly social events. With easy access to nature and an exceptional team, it’s no wonder our residents feel right at home!",
  "property_created_at": "1743797426055",
  "property_scheduletour_blurb": "At The 101 in Kirkland, WA, elevate your lifestyle with our diverse floor plans, featuring stylish studios, spacious one-bedroom, and family-friendly two-bedroom apartments. Experience vibrant community living and see what our residents love about calling The 101 home. Schedule your tour today for a personal glimpse!",
  "property_thankyou_blurb": "Thank you for reaching out to The 101 in beautiful Kirkland, WA! With our thoughtfully designed studio, one-bedroom, and two-bedroom floor plans, you’ll find the perfect space to call home. Our team is excited to connect with you soon and help you embark on your new living journey!",
  "property_virtualtours_blurb": "Step inside The 101, your future home in vibrant Kirkland, WA! Offering stylish studio, one-bedroom, and two-bedroom floor plans, our community is designed for modern living. Experience the perfect blend of comfort and convenience—take a virtual tour today and envision your new lifestyle at The 101!",
  "property_copyright": "2025 All Rights Reserved. The 101",
  "property_seo_title_home": "The 101 |  Apartments in Kirkland, WA",
  "property_seo_description_home": "Welcome to The 101 in Kirkland, WA! Luxurious living awaits with stunning skyline views, modern amenities, and a vibrant downtown vibe. Your new home is here!",
  "property_seo_title_floorplans": "Floor Plans | Kirkland, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at The 101 in Kirkland, WA! From cozy studios to spacious two-bedrooms, browse our unique floor plans tailored for you.",
  "property_seo_title_amenities": "Amenities | Kirkland, WA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at The 101 in Kirkland! Enjoy lake views, rooftop decks, and vibrant downtown living. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Kirkland, WA",
  "property_seo_description_gallery": "Experience life at The 101 in Kirkland, WA. Stunning views, high-end finishes, and vibrant amenities await. Picture your perfect home today!",
  "property_seo_title_virtualtours": "Virtual Tours | The 101 Apartments",
  "property_seo_description_virtualtours": "Step into your future at The 101 in Kirkland, WA! Take a virtual tour of our studios, one- and two-bedroom apartments, and feel at home today!",
  "property_seo_title_interactivemap": "Interactive Map | The 101 Apartments",
  "property_seo_description_interactivemap": "Find your dream apartment at The 101 in Kirkland, WA. Enjoy stunning skyline views, modern amenities, and a vibrant downtown lifestyle—all at your fingertips!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Kirkland, WA",
  "property_seo_description_neighborhood": "Uncover the vibrant Kirkland lifestyle at The 101! Dive into local favorites and hidden gems just steps from your doorstep. Your new adventure awaits!",
  "property_seo_title_contact": "Contact Us | The 101",
  "property_seo_description_contact": "Connect with The 101 in Kirkland, WA, where chic studio, one, and two-bedroom layouts await. Have questions? Reach out to our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Kirkland, WA",
  "property_seo_description_faqs": "Uncover the essentials of The 101 in Kirkland, WA. Get answers to your questions about our luxurious amenities and stunning floor plans. Your new home awaits!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Kirkland, WA",
  "property_seo_description_reviews": "Experience life at The 101 in Kirkland, WA. Our residents love the rooftop deck, modern amenities, and vibrant community just steps from Lake Washington!",
  "property_seo_title_applynow": "Apply Now | Apartments in Kirkland, WA",
  "property_seo_description_applynow": "Elevate your lifestyle at The 101 in downtown Kirkland! Enjoy stunning skyline views, modern finishes, and convenient amenities. Secure your new home today!",
  "property_seo_title_residentaccess": "Resident Access | The 101",
  "property_seo_description_residentaccess": "Experience hassle-free living at The 101 in Kirkland, WA. Log in to your resident portal to pay rent, request maintenance, and manage your home effortlessly!",
  "property_seo_title_referafriend": "Refer A Friend | The 101",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer someone to The 101 in Kirkland, WA, and share the joy of vibrant living in an exceptional community. Join us!",
  "property_seo_title_scheduletour": "Schedule a Tour | The 101",
  "property_seo_description_scheduletour": "Experience modern living at The 101 in Kirkland, WA. Schedule a tour today and find your perfect home in our vibrant community filled with amenities!",
  "property_seo_title_privacy": "Privacy Policy | The 101",
  "property_seo_description_privacy": "At The 101 in Kirkland, WA, we prioritize your privacy. Learn how we safeguard your data while you enjoy our vibrant community. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The 101",
  "property_seo_description_accessibility": "At The 101 in Kirkland, WA, we're committed to digital inclusion. Learn how we ensure accessibility for all in our vibrant apartment community.",
  "property_seo_title_sitemap": "Sitemap | The 101",
  "property_seo_description_sitemap": "Uncover the layout of The 101 in Kirkland, WA! Navigate our sitemap to find the perfect floor plan and amenities that suit your lifestyle.",
  "property_seo_title_thankyou": "Thank You | The 101",
  "property_seo_description_thankyou": "Thank you for reaching out! A team member will connect soon to share how The 101 in Kirkland, WA, redefines modern living just for you. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Kirkland, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1777626632642",
  "amenities": [
    {
      "id": "ec_e49dded169f92d2e8287a651",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615363",
      "title": "Built Green for Maximum Energy Efficiency",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b166935da8d04788769ffa5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615816",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41ee90d334baf1d049043d04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615818",
      "title": "Controlled Access Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c986cf9e54177ed38d0f14b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615119",
      "title": "Full Menu of Concierge Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9df7e2c790f47bb4276cc375",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615819",
      "title": "Interactive Online Resident Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eb3a2da3f21313fd849d084f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615820",
      "title": "Free Wi-Fi Internet Access Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6eced1a0c2eafcbd7e67d10c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "26690143",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8691474dc4c7628786f6d06b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "26690144",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a77dbc6babfd276d8203478c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "26690145",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4e170613647cfe27efc7d01",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "26690146",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b1dc3802d2db5e8801a89af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615817",
      "title": "Rooftop Deck with Fire Pit and Barbeque",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16b3369202aa1631d7a1fcdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615821",
      "title": "On-Site Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_81ad7f051387cc6e5569e3b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615822",
      "title": "Pet Friendly Apartments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7afc0733fcb15df0c0ee22e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615845",
      "title": "Large Private Patios*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6b0950350155932153917147",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615815",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f104386dfd33d6f058403c90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615844",
      "title": "Upscale Appliance Package in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30393087d55ae73c1dba83d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615851",
      "title": "Advanced Data Wiring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bf9b93ec54e392055eaed4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615852",
      "title": "Washer and Dryer in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6242e64f317564c987d796b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "26690141",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_207b7d9f62079ab13be9ec86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "26690142",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17093f48ae5adc687b77f2a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615846",
      "title": "Amazing Views of Lake Washington*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a5ab6f8c2170013fe55e84b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615847",
      "title": "All Wood Cabinetry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc80aa2e002388d2ca70ceb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615848",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a072109f6f6b050e20ff4ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615849",
      "title": "Mobile Islands in Kitchens in Every Home",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_771352e6f92a7652dba7eecc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "yardi",
      "external_id": "13615850",
      "title": "Tiled Bathrooms",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_ae01de51ddabdb0261a8b9a4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0812-dd14-75ff-87f4-d7c554cc8b7f.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with a fire pit and seating overlooking a lake at sunset.",
        "public_id": "019d0812-dd14-75ff-87f4-d7c554cc8b7f",
        "storage_key": "property/6767906449164270/019d0812-dd14-75ff-87f4-d7c554cc8b7f.webp",
        "width": 648,
        "height": 385
      },
      "title": "Community",
      "description": "Enjoy evenings by the fire pit in our rooftop lounge, complete with stunning lake views.",
      "link": "false",
      "alt_text": "Rooftop lounge area with a fire pit and seating overlooking a lake at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/The 101 - Rooftop Deck View.jpg"
    },
    {
      "id": "ec_ccf8b427d5acc9e1249f56e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-1fdc-770f-8611-87c51c040731.webp",
      "image_media": {
        "alt_text": "Living room and kitchen of an apartment with white couch, island, and stainless steel appliances.",
        "public_id": "019d20ac-1fdc-770f-8611-87c51c040731",
        "storage_key": "property/6767906449164270/019d20ac-1fdc-770f-8611-87c51c040731.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a modern kitchen with stainless steel appliances and a center island, seamlessly connected to a comfortable living room.",
      "link": "false",
      "alt_text": "Living room and kitchen of an apartment with white couch, island, and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Pillar_Livingroom_F_cam1.jpg"
    },
    {
      "id": "ec_95f118f4664e3ec53bc14009",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-2451-7028-991d-84a2b83f3b5a.webp",
      "image_media": {
        "alt_text": "Rooftop lounge area with seating, tables, umbrellas, and a grill, overlooking a marina and bay.",
        "public_id": "019d20ac-2451-7028-991d-84a2b83f3b5a",
        "storage_key": "property/6767906449164270/019d20ac-2451-7028-991d-84a2b83f3b5a.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy the outdoors on our spacious rooftop deck, featuring comfortable seating, dining areas, and a barbecue grill. Perfect for relaxing or entertaining while taking in the scenic waterfront views.",
      "link": "false",
      "alt_text": "Rooftop lounge area with seating, tables, umbrellas, and a grill, overlooking a marina and bay.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/LCP360 - The 101 rooftop areial.jpg"
    },
    {
      "id": "ec_dded998127df5e2a252792cb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-1fc1-7133-b914-f5829a01b03e.webp",
      "image_media": {
        "alt_text": "Luxurious bedroom with a king-size bed, plush seating, and modern decor.",
        "public_id": "019d20ac-1fc1-7133-b914-f5829a01b03e",
        "storage_key": "property/6767906449164270/019d20ac-1fc1-7133-b914-f5829a01b03e.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Experience ultimate comfort in this spacious bedroom, featuring a king-size bed, a cozy accent chair, and elegant wall art. A perfect retreat for relaxation.",
      "link": "false",
      "alt_text": "Luxurious bedroom with a king-size bed, plush seating, and modern decor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Pillar_bedroom_F_cam1.jpg"
    },
    {
      "id": "ec_8e2b10244d7d989c377b5217",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-27ca-7391-8c5e-f76c78b31fca.webp",
      "image_media": {
        "alt_text": "Modern apartment lobby with a sleek fireplace, comfortable seating area, and large windows.",
        "public_id": "019d20ac-27ca-7391-8c5e-f76c78b31fca",
        "storage_key": "property/6767906449164270/019d20ac-27ca-7391-8c5e-f76c78b31fca.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish apartment lobby, featuring a stunning fireplace, plush seating, and a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Modern apartment lobby with a sleek fireplace, comfortable seating area, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/LCP360 - The 101 lobby fireplace.jpg"
    },
    {
      "id": "ec_247cc6156c8abc9dbd7d8e44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-2d80-735b-9131-09719d01a186.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, coffee table, and TV.",
        "public_id": "019d20ac-2d80-735b-9131-09719d01a186",
        "storage_key": "property/6767906449164270/019d20ac-2d80-735b-9131-09719d01a186.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Spacious living area with elegant furnishings, perfect for relaxing or entertaining.",
      "link": "false",
      "alt_text": "Living room with a white sofa, coffee table, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/Pillar_Livingroom2_F_cam1.jpg"
    },
    {
      "id": "ec_b0b026c704dcbaab82ddd912",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-05c8-71e7-8dd0-16651852405d.webp",
      "image_media": {
        "alt_text": "Empty room with large windows and hardwood floors",
        "public_id": "019d0813-05c8-71e7-8dd0-16651852405d",
        "storage_key": "property/6767906449164270/019d0813-05c8-71e7-8dd0-16651852405d.webp",
        "width": 344,
        "height": 385
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with abundant natural light and scenic views, featuring gleaming hardwood floors.",
      "link": "false",
      "alt_text": "Empty room with large windows and hardwood floors",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_37_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_6d4c8031586424ed80c245b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-32cf-7572-b5b3-2ae4be411eb5.webp",
      "image_media": {
        "alt_text": "Modern apartment building exterior with brick and siding, balconies, and parking.",
        "public_id": "019d20ac-32cf-7572-b5b3-2ae4be411eb5",
        "storage_key": "property/6767906449164270/019d20ac-32cf-7572-b5b3-2ae4be411eb5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment building featuring a mix of brick and siding, private balconies, and convenient resident parking.",
      "link": "false",
      "alt_text": "Modern apartment building exterior with brick and siding, balconies, and parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/LCP360 - The 101 exterior edited.jpg"
    },
    {
      "id": "ec_6b05b8485b89d47c6dd95a89",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-3483-7373-b76c-70fe854487d1.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island seating.",
        "public_id": "019d20ac-3483-7373-b76c-70fe854487d1",
        "storage_key": "property/6767906449164270/019d20ac-3483-7373-b76c-70fe854487d1.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "A beautifully appointed kitchen featuring dark wood cabinetry, a spacious island with bar stools, and stainless steel appliances. Perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and island seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/LCP360 - The 101 kitchen.jpg"
    },
    {
      "id": "ec_225be76a716c7442e08f7103",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-75e4-77aa-9604-813db3635dbe.webp",
      "image_media": {
        "alt_text": "Rooftop terrace with lounge chairs, dining tables, umbrellas, and grills.",
        "public_id": "019d20ac-75e4-77aa-9604-813db3635dbe",
        "storage_key": "property/6767906449164270/019d20ac-75e4-77aa-9604-813db3635dbe.webp",
        "width": 3072,
        "height": 1726
      },
      "title": "Community",
      "description": "Enjoy stunning city views and relax on our spacious rooftop terrace, featuring comfortable lounge areas, outdoor dining, and barbecue grills.",
      "link": "false",
      "alt_text": "Rooftop terrace with lounge chairs, dining tables, umbrellas, and grills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/LCP360 - The 101 rooftop deck aerial.jpg"
    },
    {
      "id": "ec_7c8007e2eab9f11e94be9025",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d20ac-3c1b-7536-a433-43301b7130dc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, toilet, and bathtub/shower combo.",
        "public_id": "019d20ac-3c1b-7536-a433-43301b7130dc",
        "storage_key": "property/6767906449164270/019d20ac-3c1b-7536-a433-43301b7130dc.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom, featuring a spacious vanity with ample counter space, a modern toilet, and a relaxing bathtub with a shower.",
      "link": "false",
      "alt_text": "Modern bathroom with a vanity, toilet, and bathtub/shower combo.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/4140/LCP360 - The 101 bathroom.jpg"
    },
    {
      "id": "ec_afc00cfb4060f9a0ebe28d1f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-2e03-741f-83c6-a98a26640248.webp",
      "image_media": {
        "alt_text": "Rooftop patio with tables, chairs, umbrellas, and a grill overlooking the water at sunset.",
        "public_id": "019d0813-2e03-741f-83c6-a98a26640248",
        "storage_key": "property/6767906449164270/019d0813-2e03-741f-83c6-a98a26640248.webp",
        "width": 1732,
        "height": 1154
      },
      "title": "Community",
      "description": "Enjoy stunning sunset views from our expansive rooftop patio, complete with comfortable seating, outdoor dining areas, and a barbecue grill.",
      "link": "false",
      "alt_text": "Rooftop patio with tables, chairs, umbrellas, and a grill overlooking the water at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/The 101 - Rooftop Deck View(1).jpg"
    },
    {
      "id": "ec_b79ebb5744481e73bcb56b84",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-3797-73de-8e53-a1fb70bf31a2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and wooden cabinets",
        "public_id": "019d0813-3797-73de-8e53-a1fb70bf31a2",
        "storage_key": "property/6767906449164270/019d0813-3797-73de-8e53-a1fb70bf31a2.webp",
        "width": 345,
        "height": 385
      },
      "title": "Apartment",
      "description": "A beautifully designed kitchen featuring sleek stainless steel appliances, granite countertops, and rich wood cabinetry, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and wooden cabinets",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_36_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_5d52fc4c78155b7a77e483b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-3e87-74c8-a6f6-e96d1fb5101a.webp",
      "image_media": {
        "alt_text": "Rooftop patio with fire pit, lounge chairs, and grills at dusk.",
        "public_id": "019d0813-3e87-74c8-a6f6-e96d1fb5101a",
        "storage_key": "property/6767906449164270/019d0813-3e87-74c8-a6f6-e96d1fb5101a.webp",
        "width": 2000,
        "height": 1200
      },
      "title": "Community",
      "description": "Enjoy the stunning city views from our rooftop patio, complete with a fire pit, comfortable lounge seating, and grilling stations for the perfect evening gathering.",
      "link": "false",
      "alt_text": "Rooftop patio with fire pit, lounge chairs, and grills at dusk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/The 101 - Rooftop Deck Fire Pit.jpg"
    },
    {
      "id": "ec_f4fcf08f407f10d086d04e86",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-39b2-720e-b624-dc3bb86f72d6.webp",
      "image_media": {
        "alt_text": "Rooftop grilling station with a built-in grill and sink, overlooking a body of water.",
        "public_id": "019d0813-39b2-720e-b624-dc3bb86f72d6",
        "storage_key": "property/6767906449164270/019d0813-39b2-720e-b624-dc3bb86f72d6.webp",
        "width": 612,
        "height": 408
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking and dining with a view on our rooftop terrace, featuring a state-of-the-art grill and ample seating.",
      "link": "false",
      "alt_text": "Rooftop grilling station with a built-in grill and sink, overlooking a body of water.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/The 101 - Rooftop Deck Grill.jpg"
    },
    {
      "id": "ec_6f7aea296bcb1069922619b3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-439a-779a-97f0-43a2abe9a182.webp",
      "image_media": {
        "alt_text": "Modern brick building with Bank of America signage and a stone water feature in front.",
        "public_id": "019d0813-439a-779a-97f0-43a2abe9a182",
        "storage_key": "property/6767906449164270/019d0813-439a-779a-97f0-43a2abe9a182.webp",
        "width": 1732,
        "height": 1154
      },
      "title": "Community",
      "description": "Exterior view of a mixed-use building featuring Bank of America on the ground floor, with a contemporary stone water fountain and seating area.",
      "link": "false",
      "alt_text": "Modern brick building with Bank of America signage and a stone water feature in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/The 101 - Retail.jpg"
    },
    {
      "id": "ec_72179aacf8c4d84fb79bade4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-4629-71d7-8ab0-58d3c6da6ccc.webp",
      "image_media": {
        "alt_text": "Wooden picnic table in a park by the water with buildings in the background.",
        "public_id": "019d0813-4629-71d7-8ab0-58d3c6da6ccc",
        "storage_key": "property/6767906449164270/019d0813-4629-71d7-8ab0-58d3c6da6ccc.webp",
        "width": 1732,
        "height": 1154
      },
      "title": "Community",
      "description": "Enjoy the outdoors with a picnic table set in a scenic park, perfect for relaxing by the water. Close to local amenities.",
      "link": "false",
      "alt_text": "Wooden picnic table in a park by the water with buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/The 101 - Neighborhood.jpg"
    },
    {
      "id": "ec_7b854f6cd2652d89cf3ea687",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-4a17-77ad-a581-7974e4b70a1d.webp",
      "image_media": {
        "alt_text": "Street view of Cactus restaurant with outdoor seating and trees.",
        "public_id": "019d0813-4a17-77ad-a581-7974e4b70a1d",
        "storage_key": "property/6767906449164270/019d0813-4a17-77ad-a581-7974e4b70a1d.webp",
        "width": 346,
        "height": 385
      },
      "title": "Community",
      "description": "Exterior view of the Cactus restaurant, featuring outdoor seating and a vibrant streetscape. Perfect for enjoying a meal al fresco.",
      "link": "false",
      "alt_text": "Street view of Cactus restaurant with outdoor seating and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_04_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_48477de517bf9253298d3fd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-5062-77ed-86eb-62491b063cab.webp",
      "image_media": {
        "alt_text": "Bronze statue of a child holding a bird",
        "public_id": "019d0813-5062-77ed-86eb-62491b063cab",
        "storage_key": "property/6767906449164270/019d0813-5062-77ed-86eb-62491b063cab.webp",
        "width": 345,
        "height": 385
      },
      "title": "Community",
      "description": "Charming bronze statue of a child gently holding a small bird, adding a touch of whimsy to the community grounds.",
      "link": "false",
      "alt_text": "Bronze statue of a child holding a bird",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_15_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_cda946e80027e96f757422d8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-527a-730d-abc3-0f07ea03829d.webp",
      "image_media": {
        "alt_text": "Lake view with tall grass in the foreground and cloudy skies.",
        "public_id": "019d0813-527a-730d-abc3-0f07ea03829d",
        "storage_key": "property/6767906449164270/019d0813-527a-730d-abc3-0f07ea03829d.webp",
        "width": 346,
        "height": 385
      },
      "title": "Community",
      "description": "Enjoy the serene lake views from this beautiful community, complete with lush greenery and dramatic skies.",
      "link": "false",
      "alt_text": "Lake view with tall grass in the foreground and cloudy skies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_18_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_f17ecf6c2fc07a2b3c5f90ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-527a-730d-abc3-0869f1970f1c.webp",
      "image_media": {
        "alt_text": "Welcome to Lee Johnson Field sign at a baseball park.",
        "public_id": "019d0813-527a-730d-abc3-0869f1970f1c",
        "storage_key": "property/6767906449164270/019d0813-527a-730d-abc3-0869f1970f1c.webp",
        "width": 344,
        "height": 385
      },
      "title": "Community",
      "description": "Signage for Lee Johnson Field at a baseball stadium. Enjoy a day at the park with friends and family.",
      "link": "false",
      "alt_text": "Welcome to Lee Johnson Field sign at a baseball park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_31_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_c8999eafb4fab605e53f5f98",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-5478-735a-857d-05aab879ef3d.webp",
      "image_media": {
        "alt_text": "View of a marina with sailboats, docks, and a distant shoreline, framed by palm fronds and lush green bushes.",
        "public_id": "019d0813-5478-735a-857d-05aab879ef3d",
        "storage_key": "property/6767906449164270/019d0813-5478-735a-857d-05aab879ef3d.webp",
        "width": 346,
        "height": 385
      },
      "title": "Community",
      "description": "Enjoy scenic waterfront living with a view of the marina and sailboats right from your doorstep. Lush landscaping adds to the serene ambiance.",
      "link": "false",
      "alt_text": "View of a marina with sailboats, docks, and a distant shoreline, framed by palm fronds and lush green bushes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_17_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_5ee1405b6cf04628397e6d42",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-5a80-7453-826b-995295d46b13.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with brick accents and balconies.",
        "public_id": "019d0813-5a80-7453-826b-995295d46b13",
        "storage_key": "property/6767906449164270/019d0813-5a80-7453-826b-995295d46b13.webp",
        "width": 345,
        "height": 385
      },
      "title": "Community",
      "description": "A stylish apartment building featuring a mix of brick and modern facade, with balconies and street-level retail spaces. Ample parking is available along the street.",
      "link": "false",
      "alt_text": "Exterior view of a modern apartment building with brick accents and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_12_Image_Collegiate_1_PhotoGallery.jpg"
    },
    {
      "id": "ec_2aea444817df12a9700d7cb5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0813-5d59-7298-88b4-c7965570df35.webp",
      "image_media": {
        "alt_text": "The 101 Luxury Apartment Living sign on a brick building exterior.",
        "public_id": "019d0813-5d59-7298-88b4-c7965570df35",
        "storage_key": "property/6767906449164270/019d0813-5d59-7298-88b4-c7965570df35.webp",
        "width": 580,
        "height": 385
      },
      "title": "Community",
      "description": "Exterior signage for The 101 Luxury Apartment Living, featuring the property's name and address on a prominent brick building.",
      "link": "false",
      "alt_text": "The 101 Luxury Apartment Living sign on a brick building exterior.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/3/77603/WA_Kirkland_The101_P0081336_01_Image_Collegiate_1_PhotoGallery.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ca3f6071-137f-45d1-a4ac-98c797493425",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Marymoor Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6046 West Lake Sammamish Pkwy NE, Redmond, WA 98052, USA",
      "poi_short_description": "Huge outdoor space for dogs, featuring riverside trails, climbing walls and soccer fields.",
      "poi_long_description": "People say this park offers a wide variety of outdoor activities, including biking, running, and sports fields, as well as a dog park, climbing wall, and velodrome. They highlight the spacious grounds, well-maintained trails, and convenient parking, and like the family-friendly atmosphere and opportunities for picnics and outdoor concerts. They also mention the clean restrooms and the availability of food trucks during events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-61fc-7213-8041-f8467d143f7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-61fc-7213-8041-f8467d143f7d",
        "storage_key": "property/6767906449164270/019d0814-61fc-7213-8041-f8467d143f7d.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.kingcounty.gov/services/parks-recreation/parks/parks-and-natural-lands/popular-parks/marymoor.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=732428507287546141&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "marymoor-park",
      "poi_latitude": "47.6627419",
      "poi_longitude": "-122.1216252",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-477-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fWNvq9ykFQRHWk-yNgbKgo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2f7c1785-ab98-48bf-b29d-dab1723637e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Warren G. Magnuson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 Sand Point Way NE, Seattle, WA 98115, USA",
      "poi_short_description": "Lakefront park featuring playgrounds and water sports facilities.",
      "poi_long_description": "People say this city park offers a dog park, beach, soccer fields, walking trails, and picnic areas. They highlight the peaceful and spacious atmosphere, and the beautiful views of the lake and mountains. They also like the ample parking and the availability of restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-6388-7358-a01d-64253d503ffb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-6388-7358-a01d-64253d503ffb",
        "storage_key": "property/6767906449164270/019d0814-6388-7358-a01d-64253d503ffb.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/magnuson-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13794854175829797151&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "warren-g-magnuson-park",
      "poi_latitude": "47.6797687",
      "poi_longitude": "-122.2536022",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "1 hour 7 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTSbT3aATkFQRHymm3sgqcb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_65532276-9b39-42af-a224-7491962a5926",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Bellevue Downtown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10201 NE 4th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Large, grassy waterfront area featuring winding paths, playgrounds and picnic spots.",
      "poi_long_description": "Visitors say this urban park offers a playground, walking paths, a large lawn for picnics, and a water feature with ducks. They also highlight the park's clean and well-maintained facilities, family-friendly atmosphere, and convenient location near shops and restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-6404-7590-b0bc-5ecf9c1a1455.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-6404-7590-b0bc-5ecf9c1a1455",
        "storage_key": "property/6767906449164270/019d0814-6404-7590-b0bc-5ecf9c1a1455.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://parks.bellevuewa.gov/parks-and-trails/parks/bellevue-downtown-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4725159899354261845&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bellevue-downtown-park",
      "poi_latitude": "47.6126836",
      "poi_longitude": "-122.2041686",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVqRI4dskFQRVWnuu-Qjk0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_512e96fd-4c9f-4538-83e1-e1eca543fb3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Washington Park Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 Arboretum Dr E, Seattle, WA 98112, USA",
      "poi_short_description": "Lakefront natural escape with hiking and paved paths, plus a visitor center and an arboretum.",
      "poi_long_description": "People say this botanical garden offers a wide variety of trees, plants, and flowers, including cherry blossoms, magnolias, and rhododendrons. They highlight the well-maintained trails, beautiful views, and relaxing atmosphere, perfect for walking, running, biking, and picnics. They also like the free parking and entry, and the helpful staff and volunteers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-65e1-7611-88f1-a9daedf7fabf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-65e1-7611-88f1-a9daedf7fabf",
        "storage_key": "property/6767906449164270/019d0814-65e1-7611-88f1-a9daedf7fabf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://botanicgardens.uw.edu/washington-park-arboretum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11695386533940199050&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "washington-park-arboretum",
      "poi_latitude": "47.6364162",
      "poi_longitude": "-122.2958146",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-543-8800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgTy59sYUkFQRin5kehZcTqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_4e682f08-1969-48fc-939e-b173db0782fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Green Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7201 East Green Lake Dr N, Seattle, WA 98115, USA",
      "poi_short_description": "Popular park at a scenic lake for swimming and paddle boating, along with tennis courts, playgrounds and picnic areas.",
      "poi_long_description": "People say this park offers a beautiful lake with a walking path, opportunities for biking, kayaking, paddle boating, and fishing, and a playground. They highlight the relaxing and fun vibe, and the scenic views, especially at sunset. They also like the availability of picnic areas, benches, and nearby restaurants and coffee shops.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-6873-77f3-b753-b27eebf5ee6f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d0814-6873-77f3-b753-b27eebf5ee6f",
        "storage_key": "property/6767906449164270/019d0814-6873-77f3-b753-b27eebf5ee6f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.seattle.gov/parks/find/parks/green-lake-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=12201424080476219256&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "green-lake-park",
      "poi_latitude": "47.6802143",
      "poi_longitude": "-122.3284021",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 206-684-4075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJEbIG9xUUkFQReKeuJo4qVKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fd737c17-2417-4232-bfe3-1b41c32a7302",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Isarn Thai Soul Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "170 Lake St S, Kirkland, WA 98033, USA",
      "poi_short_description": "Inventive takes on traditional Thai meals & cocktails in a hip, rustic-chic setting.",
      "poi_long_description": "People say this Thai restaurant serves delicious dishes, including Chiang Mai Noodles, mushroom fritters, and crab fried rice. They also highlight the vibrant and welcoming atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-c4d9-76a9-b6a4-60d6d4246658.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c4d9-76a9-b6a4-60d6d4246658",
        "storage_key": "property/6767906449164270/019dbbe6-c4d9-76a9-b6a4-60d6d4246658.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.isarnkitchen.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2720001304182696197&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "isarn-thai-soul-kitchen",
      "poi_latitude": "47.674316",
      "poi_longitude": "-122.2058128",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-298-4429",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c95-7438-af36-ba2414c26cb1",
        "storage_key": "property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJj6QLlt0SkFQRBaloZMZivyU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_51e1dac3-4ab8-4669-8ffb-b14b6320b8aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Cactus Kirkland",
      "poi_type": "Restaurants",
      "poi_address": "121 Park Ln, Kirkland, WA 98033, USA",
      "poi_short_description": "Vibrant outpost offering a Southwestern-Mexican menu & a long list of tequila drinks.",
      "poi_long_description": "People say this Mexican restaurant serves delicious carne asada, fresh Austin-style guacamole, and strong margaritas. They highlight the generous portions, reasonable prices, and authentic but fancy vibe. They also like the attentive and friendly service, and the complimentary dessert offered to first-time diners.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-c131-7258-b169-59dc23523ba9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c131-7258-b169-59dc23523ba9",
        "storage_key": "property/6767906449164270/019dbbe6-c131-7258-b169-59dc23523ba9.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.cactusrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17470731258214949166&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cactus-kirkland",
      "poi_latitude": "47.6760028",
      "poi_longitude": "-122.2058194",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-893-9799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c95-7438-af36-ba2414c26cb1",
        "storage_key": "property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCeaTgucSkFQRLiE39IOBdPI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_434a0cd1-d6d7-4d92-94cf-73236571cec3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "George's",
      "poi_type": "Restaurants",
      "poi_address": "108 Kirkland Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "Longtime mom-&-pop with a bar serving American & Mediterranean dishes from breakfast to dinner.",
      "poi_long_description": "People say this diner offers a wide variety of classic American breakfast dishes, as well as innovative options with Greek flair, such as the Olympic Omelet and Gyro Benedict. They also highlight the generous portions, fresh ingredients, and reasonable prices, and like the friendly, attentive service and cozy, diner-style atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-c100-74af-beb8-984d4daddcbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c100-74af-beb8-984d4daddcbf",
        "storage_key": "property/6767906449164270/019dbbe6-c100-74af-beb8-984d4daddcbf.webp",
        "width": 1200,
        "height": 673
      },
      "poi_business_url": "http://www.georgeskirkland.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13096397431670090470&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "georges",
      "poi_latitude": "47.6756434",
      "poi_longitude": "-122.2060673",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-827-6622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c95-7438-af36-ba2414c26cb1",
        "storage_key": "property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJARSsf-cSkFQR5qoIkBPAv7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "diner"
    },
    {
      "id": "custom_e23fe9a4-d75e-44bc-95e1-e5dffddfa644",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Acropolis Pizza & Pasta - Kirkland",
      "poi_type": "Restaurants",
      "poi_address": "500 Central Way, Kirkland, WA 98033, USA",
      "poi_short_description": "Pizzas & grinders with secret sauce are found on an Italian & Greek menu at this no-frills diner.",
      "poi_long_description": "People say this Italian restaurant serves delicious grinders, lasagna, and pizza. They highlight the affordable prices and family-owned atmosphere. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-c421-748b-8fb6-2909a1bf7a93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c421-748b-8fb6-2909a1bf7a93",
        "storage_key": "property/6767906449164270/019dbbe6-c421-748b-8fb6-2909a1bf7a93.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://acropolispizzapasta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3110277603545565918&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "acropolis-pizza--pasta---kirkland",
      "poi_latitude": "47.6791373",
      "poi_longitude": "-122.1985533",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-827-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c95-7438-af36-ba2414c26cb1",
        "storage_key": "property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6-gwekSkFQR3sovYADtKSs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_ff2f8039-435d-419b-8687-46730f66341e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Alanya Doner",
      "poi_type": "Restaurants",
      "poi_address": "1 Lake St S, Kirkland, WA 98033, USA",
      "poi_short_description": "Quaint Mediterranean eatery providing sizable sandwiches, gyros & Turkish pizzas.",
      "poi_long_description": "Diners say this Turkish restaurant serves delicious beef gyro, egg and sausage, and kenafe. They also highlight the friendly and welcoming atmosphere, with the management and chef creating a contagious energy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-c969-705a-94c7-c761ea11a0f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-c969-705a-94c7-c761ea11a0f1",
        "storage_key": "property/6767906449164270/019dbbe6-c969-705a-94c7-c761ea11a0f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9683596153222687154&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "alanya-doner",
      "poi_latitude": "47.6756221",
      "poi_longitude": "-122.2067827",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-739-4747",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c95-7438-af36-ba2414c26cb1",
        "storage_key": "property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXXvSCucSkFQRsmktPWULY4Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "turkish_restaurant"
    },
    {
      "id": "custom_4fc4218d-9d6b-485c-a5e7-6994c026fa79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Google Kirkland - Kirkland Urban",
      "poi_type": "Major Employers & Offices",
      "poi_address": "425 Urban Plz Suite#223, Kirkland, WA 98033, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-caea-7636-9dc0-61276fd55e89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-caea-7636-9dc0-61276fd55e89",
        "storage_key": "property/6767906449164270/019dbbe6-caea-7636-9dc0-61276fd55e89.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://about.google/company-info/locations/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12392096200761415899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "google-kirkland---kirkland-urban",
      "poi_latitude": "47.6775887",
      "poi_longitude": "-122.1992122",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-80fe-7798-879e-3d41378a63c9",
        "storage_key": "property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF0JJdpgTkFQR2xjapNaR-as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9846c393-387b-4451-b2f5-012654bd3be1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Microsoft Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15010 NE 36th St, Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-d455-72c7-b122-d7d9927f2183.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d455-72c7-b122-d7d9927f2183",
        "storage_key": "property/6767906449164270/019dbbe6-d455-72c7-b122-d7d9927f2183.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10742286853900103859&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "microsoft-corporate-headquarters",
      "poi_latitude": "47.6423109",
      "poi_longitude": "-122.1368406",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-882-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-80fe-7798-879e-3d41378a63c9",
        "storage_key": "property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJixNL7SRtkFQRs3AQgvpEFJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_86c3a6fa-5690-4723-b54e-967483dcd9d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "EvergreenHealth Medical Center Kirkland",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12040 NE 128th St, Kirkland, WA 98034, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-d379-7022-987a-0f3848534ba1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d379-7022-987a-0f3848534ba1",
        "storage_key": "property/6767906449164270/019dbbe6-d379-7022-987a-0f3848534ba1.webp",
        "width": 600,
        "height": 563
      },
      "poi_business_url": "https://www.evergreenhealth.com/?utm_source=EH-MEDCENTER&utm_campaign=Local-Listings&utm_medium=Google-My-Business",
      "poi_directions_map_url": "https://maps.google.com/?cid=14406417902947637237&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "evergreenhealth-medical-center-kirkland",
      "poi_latitude": "47.7156418",
      "poi_longitude": "-122.1795593",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 425-899-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-813d-734f-86e8-cc60f4eec968.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-813d-734f-86e8-cc60f4eec968",
        "storage_key": "property/6767906449164270/019d0814-813d-734f-86e8-cc60f4eec968.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-7eSYUNkFQR9ZcFF8Hg7cc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_537234c7-9168-49b2-a396-2b78ac409805",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "8629 120th Ave NE #8b, Kirkland, WA 98033, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including groceries, household items, clothing, and electronics. They highlight the great prices, especially on bulk items, and the consistent quality of the products. They also like the friendly and helpful staff, and the fast checkout process.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-d373-74ff-b9d8-584318641f04.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d373-74ff-b9d8-584318641f04",
        "storage_key": "property/6767906449164270/019dbbe6-d373-74ff-b9d8-584318641f04.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/kirkland-WA-8.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=10677523820666503650&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "47.6807329",
      "poi_longitude": "-122.1816895",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-827-1693",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c89-70db-8b6c-bb254f9a671e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c89-70db-8b6c-bb254f9a671e",
        "storage_key": "property/6767906449164270/019d0814-7c89-70db-8b6c-bb254f9a671e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ90KjFL4SkFQR4kGZy1cvLpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_d52fd0f4-a343-44e9-80b5-66412c3195cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Kirkland Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "255 Central Way, Kirkland, WA 98033, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-d50c-723d-8d3e-dc631cc0739d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d50c-723d-8d3e-dc631cc0739d",
        "storage_key": "property/6767906449164270/019dbbe6-d50c-723d-8d3e-dc631cc0739d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jshproperties.com/listing/184911.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12596484746789755452&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kirkland-square",
      "poi_latitude": "47.6771075",
      "poi_longitude": "-122.2038207",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-455-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c89-70db-8b6c-bb254f9a671e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c89-70db-8b6c-bb254f9a671e",
        "storage_key": "property/6767906449164270/019d0814-7c89-70db-8b6c-bb254f9a671e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJm25X7ecSkFQRPJoHXyO0z64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_8e772f6a-39fd-402f-afa3-6005961e497b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Metropolitan Market Kirkland",
      "poi_type": "Shopping & Retail",
      "poi_address": "10611 NE 68th St, Kirkland, WA 98033, USA",
      "poi_short_description": "Local chain outpost of upscale supermarkets with a variety of foodstuffs, plus prepared meals.",
      "poi_long_description": "People say this gourmet grocery store offers a wide variety of fresh produce, a fantastic food bar with excellent sushi, and a delicious bakery cookie. They highlight the high quality of the products, the unique and high-end selections, and the clean, neat, and tidy store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-d963-73df-917a-dbd35ecb8c78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-d963-73df-917a-dbd35ecb8c78",
        "storage_key": "property/6767906449164270/019dbbe6-d963-73df-917a-dbd35ecb8c78.webp",
        "width": 1280,
        "height": 617
      },
      "poi_business_url": "https://metropolitan-market.com/locations/kirkland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6481238114528675061&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "metropolitan-market-kirkland",
      "poi_latitude": "47.6657758",
      "poi_longitude": "-122.1973854",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-454-0085",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7cce-736f-b79d-d1320ca68648.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7cce-736f-b79d-d1320ca68648",
        "storage_key": "property/6767906449164270/019d0814-7cce-736f-b79d-d1320ca68648.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJwqmqNASkFQR9UQ04bn78Vk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_c4c845af-c4d1-4a75-9f8f-e883c3715d54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Bella Bottega Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "8976 161st Avenue Northeast, Redmond, WA 98052, USA",
      "poi_short_description": "Neighborhood commercial complex offering a supermarket, cafes, restaurants & a movie theater.",
      "poi_long_description": "Neighborhood commercial complex offering a supermarket, cafes, restaurants & a movie theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-dbd5-73f8-8cba-8b83b2f37882.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-dbd5-73f8-8cba-8b83b2f37882",
        "storage_key": "property/6767906449164270/019dbbe6-dbd5-73f8-8cba-8b83b2f37882.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.qfc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2948871459501787952&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bella-bottega-shopping-center",
      "poi_latitude": "47.68126540000001",
      "poi_longitude": "-122.1248729",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c89-70db-8b6c-bb254f9a671e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c89-70db-8b6c-bb254f9a671e",
        "storage_key": "property/6767906449164270/019d0814-7c89-70db-8b6c-bb254f9a671e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJzeqCZkwNkFQRMEvk9_d-7Cg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_5abe290a-6fa1-4190-8897-edbe665b6a25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Flatstick Pub - Kirkland",
      "poi_type": "Entertainment",
      "poi_address": "15 Lake St Suite 100, Kirkland, WA 98033, USA",
      "poi_short_description": "Washington beer on tap, simple pub grub & 9 holes of mini-golf in a modern, warehouse-like space.",
      "poi_long_description": "People say this pub offers a fun mini golf course and a rotating selection of local beers. They also highlight the friendly staff, the casual and fun atmosphere, and the great value for regulars.\n\nOther reviews mention the food can be limited.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-de29-719c-b34e-367537df01a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-de29-719c-b34e-367537df01a8",
        "storage_key": "property/6767906449164270/019dbbe6-de29-719c-b34e-367537df01a8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://flatstickpub.com/kirkland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8883584358043481051&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "flatstick-pub---kirkland",
      "poi_latitude": "47.675923499999996",
      "poi_longitude": "-122.2072226",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-242-1618",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-ffb5-7611-9191-1d457c570907.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ffb5-7611-9191-1d457c570907",
        "storage_key": "property/6767906449164270/019dbbe6-ffb5-7611-9191-1d457c570907.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBaBecOcSkFQR2_NlCejUSHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "custom_ce1c94b8-3328-4498-967c-63915fb81d74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "K1 Speed Redmond",
      "poi_type": "Entertainment",
      "poi_address": "2207 NE Bel Red Rd, Redmond, WA 98052, USA",
      "poi_short_description": "Chain of indoor racing centers featuring electric go-karting for all skill levels, plus food.",
      "poi_long_description": "Visitors say this amusement center offers fast go-karts, a challenging track, and a variety of activities, including arcade-style games. They also highlight the friendly and helpful staff who create a welcoming and energetic vibe.\n\nSome reviews mention the wait times between races can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-dedc-764e-a19a-0ef339286e14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-dedc-764e-a19a-0ef339286e14",
        "storage_key": "property/6767906449164270/019dbbe6-dedc-764e-a19a-0ef339286e14.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://k1speed.com/seattle-location.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=9584197256759721205&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "k1-speed-redmond",
      "poi_latitude": "47.6299827",
      "poi_longitude": "-122.1351551",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-455-9999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-80fe-7798-879e-3d41378a63c9",
        "storage_key": "property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYekZL6dtkFQR9bxvMqDoAYU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_108d94cf-586f-4464-a671-78c5e9eb499e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Heritage Hall",
      "poi_type": "Entertainment",
      "poi_address": "203 Market St, Kirkland, WA 98033, USA",
      "poi_short_description": "Venue suitable for small events, including memorial services.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-e548-77e2-a3c6-d01da9a4f661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e548-77e2-a3c6-d01da9a4f661",
        "storage_key": "property/6767906449164270/019dbbe6-e548-77e2-a3c6-d01da9a4f661.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kirklandwa.gov/depart/parks/Permits_and_Reservations/Facility_Rentals/heritage_hall.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12823082963081995439&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-hall",
      "poi_latitude": "47.6768221",
      "poi_longitude": "-122.2098863",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-587-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-80fe-7798-879e-3d41378a63c9",
        "storage_key": "property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwdClIecSkFQRr6Td6wO-9LE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_3166ea74-0b1e-4bb7-b7ca-284f114fbb64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Ben & Jerry’s",
      "poi_type": "Entertainment",
      "poi_address": "176 Lake St S, Kirkland, WA 98033, USA",
      "poi_short_description": "Iconic Vermont-based ice cream parlor chain, known for its creative, cleverly named flavors.",
      "poi_long_description": "Iconic Vermont-based ice cream parlor chain, known for its creative, cleverly named flavors.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-e568-753f-a3ae-0cf1cf44bfc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e568-753f-a3ae-0cf1cf44bfc2",
        "storage_key": "property/6767906449164270/019dbbe6-e568-753f-a3ae-0cf1cf44bfc2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.benjerry.com/kirkland",
      "poi_directions_map_url": "https://maps.google.com/?cid=5012507390039599964&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ben--jerrys",
      "poi_latitude": "47.674236",
      "poi_longitude": "-122.2057799",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-576-1609",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c95-7438-af36-ba2414c26cb1",
        "storage_key": "property/6767906449164270/019d0814-7c95-7438-af36-ba2414c26cb1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbReXld0SkFQRXKtU8ekAkEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ice_cream_shop"
    },
    {
      "id": "custom_260ed26a-9e24-49cc-b7f7-c8595c609f9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Kirkland Middle School",
      "poi_type": "Education",
      "poi_address": "430 18th Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-e532-70dd-b21f-30402cccfc60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e532-70dd-b21f-30402cccfc60",
        "storage_key": "property/6767906449164270/019dbbe6-e532-70dd-b21f-30402cccfc60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://kims.lwsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18409651150861261603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kirkland-middle-school",
      "poi_latitude": "47.6902724",
      "poi_longitude": "-122.2008",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-936-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c88-74b7-8d04-cde539bb6e7c",
        "storage_key": "property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAXvHL40SkFQRI1vy5S44fP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9f15dd53-1863-4c88-8b2c-f98274da7cf3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Lakeview Elementary School",
      "poi_type": "Education",
      "poi_address": "10400 NE 68th St, Kirkland, WA 98033, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-e5a1-759e-af5e-540c42a91131.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-e5a1-759e-af5e-540c42a91131",
        "storage_key": "property/6767906449164270/019dbbe6-e5a1-759e-af5e-540c42a91131.webp",
        "width": 480,
        "height": 268
      },
      "poi_business_url": "http://lakeview.lwsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16656945194580678478&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lakeview-elementary-school",
      "poi_latitude": "47.667517",
      "poi_longitude": "-122.2001338",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-936-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c88-74b7-8d04-cde539bb6e7c",
        "storage_key": "property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH9iIJtoSkFQRTpch9mZbKec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_35901839-dd55-431d-b4fa-409c2a9577c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Lake Washington High School",
      "poi_type": "Education",
      "poi_address": "12033 NE 80th St, Kirkland, WA 98033, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-ec80-7240-ae53-49a71244d2d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ec80-7240-ae53-49a71244d2d2",
        "storage_key": "property/6767906449164270/019dbbe6-ec80-7240-ae53-49a71244d2d2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://lwhs.lwsd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9312740537990196378&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lake-washington-high-school",
      "poi_latitude": "47.6731128",
      "poi_longitude": "-122.1808851",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-936-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c88-74b7-8d04-cde539bb6e7c",
        "storage_key": "property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSTYViLgSkFQRmixJpC2APYE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_b59f0042-59d7-4195-a3f0-b3bbdf5c9ae5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Bellevue College",
      "poi_type": "Education",
      "poi_address": "3000 Landerholm Cir SE, Bellevue, WA 98007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-eb5b-773a-8c8d-a25e92fc6470.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-eb5b-773a-8c8d-a25e92fc6470",
        "storage_key": "property/6767906449164270/019dbbe6-eb5b-773a-8c8d-a25e92fc6470.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "https://www.bellevuecollege.edu/?utm_source=google&utm_medium=gmb&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13504348681346997872&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bellevue-college",
      "poi_latitude": "47.5843272",
      "poi_longitude": "-122.1481496",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-564-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c88-74b7-8d04-cde539bb6e7c",
        "storage_key": "property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZWLQKB5skFQRcN6zmpMVabs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f5405b43-6f1e-4585-b961-21d13adf3dac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Kirkland Preschool",
      "poi_type": "Education",
      "poi_address": "802 2nd St, Kirkland, WA 98033, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-ed72-70b1-8230-fcda8185f9a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-ed72-70b1-8230-fcda8185f9a3",
        "storage_key": "property/6767906449164270/019dbbe6-ed72-70b1-8230-fcda8185f9a3.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.kirklandpreschool.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2361904359532319959&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kirkland-preschool",
      "poi_latitude": "47.6813857",
      "poi_longitude": "-122.2059101",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-822-4450",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c88-74b7-8d04-cde539bb6e7c",
        "storage_key": "property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYa18Se8SkFQR19ReR4ArxyA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_dcaed910-a3ec-4152-8fb3-fa7c392153cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Kirkland Library",
      "poi_type": "Entertainment",
      "poi_address": "308 Kirkland Ave, Kirkland, WA 98033, USA",
      "poi_short_description": "Well-maintained branch of King County libraries, featuring a children's zone, computers and free parking.",
      "poi_long_description": "People say this library offers a wide selection of books and comfortable spaces to work and study. They highlight the convenient location, with a nearby playground and parking garage, and the helpful and kind staff. They also like the quiet and suitable environment for studying.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-eef0-74bc-a41b-ee3379cd7bdc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-eef0-74bc-a41b-ee3379cd7bdc",
        "storage_key": "property/6767906449164270/019dbbe6-eef0-74bc-a41b-ee3379cd7bdc.webp",
        "width": 1200,
        "height": 640
      },
      "poi_business_url": "https://kcls.org/locations/kirkland/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13242990867223347738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kirkland-library",
      "poi_latitude": "47.6760175",
      "poi_longitude": "-122.2029286",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-822-2459",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-7c88-74b7-8d04-cde539bb6e7c",
        "storage_key": "property/6767906449164270/019d0814-7c88-74b7-8d04-cde539bb6e7c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ2V7abt0SkFQRGgKXhAeOyLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c27d75ad-d1a6-4063-a734-3d5d040b70a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "David E. Brink Park Pier",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Kirkland, WA 98033, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-f1f3-7774-992f-b8a21a2baa16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f1f3-7774-992f-b8a21a2baa16",
        "storage_key": "property/6767906449164270/019dbbe6-f1f3-7774-992f-b8a21a2baa16.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15790720731364952326&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "david-e-brink-park-pier",
      "poi_latitude": "47.67055329999999",
      "poi_longitude": "-122.2070043",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-80fe-7798-879e-3d41378a63c9",
        "storage_key": "property/6767906449164270/019d0814-80fe-7798-879e-3d41378a63c9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr6ko2msTkFQRBolnpNfoI9s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fishing_pier"
    },
    {
      "id": "custom_c8913d8d-99ce-4d58-9c10-686ac45394eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Heritage Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "111 Waverly Way, Kirkland, WA 98033, USA",
      "poi_short_description": "Park and playground, featuring trails, picnic tables and fields, plus a telescope.",
      "poi_long_description": "People say this park offers beautiful views, well-kept grass areas, and plenty of space to relax. They highlight the peaceful and quiet atmosphere, and the easy walking paths suitable for strolls and dog walks. They also like the free parking and the availability of tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-f4ca-750c-8efa-5f647edf125c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f4ca-750c-8efa-5f647edf125c",
        "storage_key": "property/6767906449164270/019dbbe6-f4ca-750c-8efa-5f647edf125c.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.kirklandwa.gov/Government/Departments/Parks-and-Community-Services/Online-Parks-Guide/Heritage-Park?BestBetMatch=heritage%20park|ab1c70ec-38e6-40e3-ba22-bf28ebfae84b|3c005e77-8f04-4719-adc1-a980035cb01f|en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021435524951916299&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "heritage-park",
      "poi_latitude": "47.6786397",
      "poi_longitude": "-122.2115469",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-587-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4HGl-YSkFQRCz_NOVIllsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ab978a06-0054-4bda-9d72-cba820b3b862",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Juanita Beach Park",
      "poi_type": "Education",
      "poi_address": "9703 NE Juanita Dr, Kirkland, WA 98034, USA",
      "poi_short_description": "This park features a sandy beach, volleyball & tennis courts, ball fields, fishing & a playground.",
      "poi_long_description": "People say this park offers a beautiful beach, a nice bridge on the water, and a playground for kids. They highlight the serene atmosphere, the well-maintained grounds, and the clean restrooms. They also like the ample parking and picnic tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-f4dc-7003-a815-5f00ae6e4527.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f4dc-7003-a815-5f00ae6e4527",
        "storage_key": "property/6767906449164270/019dbbe6-f4dc-7003-a815-5f00ae6e4527.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kirklandwa.gov/depart/parks/Parks_and_Open_Spaces/Online_Parks_Guide/Parks_Pop-up_Main/Parks_and_Community_Services__Juanita_Beach_Park.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15784180254516446732&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "juanita-beach-park",
      "poi_latitude": "47.7046205",
      "poi_longitude": "-122.2147696",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-587-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSZt12cSkFQRDAYwNVCsDNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_90d7c24f-4e04-4d10-8542-7f684c6a86af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "poi_name": "Peter Kirk Park",
      "poi_type": "Education",
      "poi_address": "202 3rd St, Kirkland, WA 98033, USA",
      "poi_short_description": "A seasonal pool, community center, playground & athletic fields & courts are the draw at this park.",
      "poi_long_description": "People say this park offers a baseball field, tennis court, ice rink, and a library nearby. They highlight the beautiful views, well-maintained grass, and convenient location near shops and restaurants. They also like the safe and kid-friendly atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019dbbe6-f61e-774f-80e3-d7f2efdd3b08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019dbbe6-f61e-774f-80e3-d7f2efdd3b08",
        "storage_key": "property/6767906449164270/019dbbe6-f61e-774f-80e3-d7f2efdd3b08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kirklandwa.gov/Government/Departments/Parks-and-Community-Services/Online-Parks-Guide/Peter-Kirk-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=6653328608793856006&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peter-kirk-park",
      "poi_latitude": "47.6769829",
      "poi_longitude": "-122.2023761",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 425-587-3360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0814-8508-710f-9710-bccc273bf801",
        "storage_key": "property/6767906449164270/019d0814-8508-710f-9710-bccc273bf801.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpSeRBOgSkFQRBggabR5fVVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_c75700ba05f9204ee043c04e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_66ac242f5036eb8990d5d5ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f3135718ee74fb1472323852",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6c06b8c59fdaab479f566144",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_b28bbf8c528456853111aaf7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e9eca048-af1f-4e6f-9b8e-938a88d2a2b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "rating": "5.0",
      "name": "Zhangjing “Sandy” Xu",
      "text": "I have been staying with the 101 for almost a year and it has been such a good experience.\nThis place is kept nice with great care and Dee loves her job and her tenants. Dee’s always thinking of me and trying to help me navigate the new city.\nTenants are also very nice. Dee organizes social events in the building and I have made friends there.\nIt’s a safe place. I once lost my wallet in the garage and it found its way back to me real fast.\nThe rooftop has great view of lake Washington and mountains from Olympics National Park. Great waking paths along the lake downstairs. I love that easy access to nature and have enjoyed countless sunsets here.\nI am facing the construction site so I can hear the noise throughout the day. I have been working from home most of the time and my brain tuned it out. This side does have the benefit of bright sunshine and lake view.",
      "date": "2022-02-25",
      "title": ""
    },
    {
      "id": "custom_b450a4ca-d5e9-49be-a377-3528c0259796",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "rating": "5.0",
      "name": "Russell Westbrook",
      "text": "My wife and I were fortunate to have discovered the 101 a year ago when looking to re-settle in Kirkland.\n\nThe downtown location is perfect, walkable distance to shops, restaurants, parks, lakeshore beaches, grocery stores, and health care.\n\nWe viewed several properties in this prime downtown area and found the 101 to be the best value.  Expertly maintained with all the amenities of luxury living at a reasonable price for such a choice property.\n\nAnd if you need anything, the friendly management staff is right there to help out.  Another sign of good management – low staff turnover.  The same management and maintenance staff are still here keeping things in top shape and running smoothly.  The property manager Dee Randhawa made our lease and move in seamless, and still provides excellent support, not to mention organizing regular social events in the building.  And the rooftop terrace is spectacular, with views across the lake to Seattle and Madison Park.\n\nI would highly recommend The 101 in Kirkland for anyone looking to locate in Kirkland.",
      "date": "2024-07-21",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_22df663d-91fd-4ef5-a781-63faf104b419",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d2fb9-240d-7317-b096-11d9a30b4574.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2fb9-240d-7317-b096-11d9a30b4574",
        "storage_key": "property/6767906449164270/019d2fb9-240d-7317-b096-11d9a30b4574.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "The 101",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?id=pano-8894146&tour=63b308694f57c918597bf651"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a2c78-86bf-762e-b7f5-d64025630fa2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "pillar-properties-the-101",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270"
    },
    {
      "lead_collector_id": "019a3127-39d2-75fd-876d-610b8ec36673",
      "lead_source": "LANDING_PAGE",
      "name": "The 101 landing page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "rooftop-deck-apartments-kirkland-wa-the-101",
      "search_query": "rooftop deck apartments Kirkland WA",
      "category": "Amenity",
      "h1_title": "Rooftop Deck Apartments in Kirkland, WA",
      "h2_subtitle": "Discover stunning rooftop deck apartments in Kirkland, WA. Experience luxury living at The 101, just steps from Lake Washington waterfront.",
      "page_copy": "Elevate your living experience at The 101, where our rooftop deck apartments in Kirkland, WA offer unparalleled views and premium amenities. Nestled in the heart of downtown Kirkland, just two blocks from the vibrant Lake Washington waterfront, our community perfectly blends urban convenience with serene lakeside charm.\n\nAt The 101, enjoy stunning studios to spacious two-bedroom layouts, each designed with high-end finishes that emphasize style and comfort. Relax on our exclusive rooftop deck, featuring views of Lake Washington and the Seattle skyline, or connect with neighbors around the grill and fire pits. Modern amenities like resident package lockers add ease to your daily routine. Discover the ultimate in lakeside urban living at The 101 today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rooftop Deck Apartments in Kirkland, WA",
      "seo_description": "Find rooftop deck apartments in Kirkland, WA at The 101. Experience luxury living with stunning views and modern amenities near Lake Washington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "air-conditioning-apartments-kirkland-the-101",
      "search_query": "amenities with air conditioning Kirkland",
      "category": "Amenity",
      "h1_title": "Amenities with Air Conditioning in Kirkland",
      "h2_subtitle": "Explore apartments with amenities like air conditioning in Kirkland. The 101 offers premier comfort and convenience in a prime location.",
      "page_copy": "The 101 in downtown Kirkland presents apartments that offer the perfect blend of comfort and modern conveniences, including amenities with air conditioning. Situated in a dynamic neighborhood, The 101 ensures you stay cool and connected to everything the vibrant city has to offer.\n\nOur range of studios and two-bedroom apartments feature high-end finishes that reflect both style and functionality. Residents here enjoy breathtaking views, especially from our rooftop deck overlooking Lake Washington and the Seattle skyline. Additional community features include grill and fire pits, adding to the lifestyle appeal. Experience the best of lakeside urban living, where every detail is designed for your comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Amenities with Air Conditioning in Kirkland",
      "seo_description": "Discover amenities with air conditioning in Kirkland at The 101. Enjoy comfort and style in a prime location near Lake Washington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "downtown-kirkland-luxury-apartments-the-101",
      "search_query": "downtown Kirkland luxury apartments",
      "category": "Amenity",
      "h1_title": "Downtown Kirkland Luxury Apartments",
      "h2_subtitle": "Experience downtown Kirkland luxury apartments at The 101. Enjoy upscale living with stunning lake views and modern conveniences.",
      "page_copy": "Welcome to The 101, where downtown Kirkland luxury apartments redefine lakeside urban living. Located just steps from the bustling Lake Washington waterfront, our community offers a seamless blend of sophistication and convenience in one of the area's most vibrant neighborhoods.\n\nAt The 101, choose from exquisite studios and two-bedroom apartments that boast high-end finishes and thoughtfully designed spaces. Our community amenities, including a rooftop deck with panoramic views of Lake Washington and the Seattle skyline, provide residents with an unparalleled lifestyle. Whether relaxing on our deck or exploring the nearby attractions, experience the pinnacle of luxury living in downtown Kirkland at The 101.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Downtown Kirkland Luxury Apartments",
      "seo_description": "Discover downtown Kirkland luxury apartments at The 101. Enjoy upscale finishes and stunning views near Lake Washington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-king-county-the-101",
      "search_query": "in unit laundry apartments King County",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in King County",
      "h2_subtitle": "Discover in-unit laundry apartments in King County at The 101. Enjoy effortless living with modern amenities in Kirkland's vibrant cultural scene.",
      "page_copy": "The 101 offers in-unit laundry apartments in King County, situated in the lively heart of downtown Kirkland. Here, enjoy the perfect fusion of urban appeal and lakeside tranquility, with Lake Washington just two blocks away.\n\nOur apartment homes, ranging from chic studios to spacious two-bedroom layouts, feature in-unit laundry, high-end finishes, and an array of conveniences designed to enhance your lifestyle. Relax and unwind on our rooftop deck, boasting breathtaking views of Lake Washington and the Seattle skyline, or gather around our grill and fire pits. For those seeking comfort and style, The 101 provides an unmatched living experience in King County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in King County",
      "seo_description": "Find in-unit laundry apartments in King County at The 101. Enjoy modern amenities near Lake Washington in downtown Kirkland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "controlled-access-parking-apartments-moss-bay-the-101",
      "search_query": "controlled access parking Moss Bay apartments",
      "category": "Amenity",
      "h1_title": "Controlled Access Parking in Moss Bay",
      "h2_subtitle": "Discover Moss Bay apartments with controlled access parking at The 101. Experience a secure and convenient lifestyle near Lake Washington.",
      "page_copy": "Situated in the picturesque neighborhood of Moss Bay, The 101 offers the ideal combination of convenience and security with controlled access parking for residents. This feature provides peace of mind, ensuring easy and safe access to your vehicle at any time.\n\nOur upscale apartments, ranging from studios to two-bedroom layouts, come equipped with high-end finishes that exemplify modern living. Nestled just two blocks from the Lake Washington waterfront, The 101 also boasts a rooftop deck with stunning views and amenities such as resident package lockers and grill areas. Embrace the serenity and vibrant community of Kirkland in our Moss Bay apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Controlled Access Parking in Moss Bay",
      "seo_description": "Explore Moss Bay apartments with controlled access parking at The 101. Enjoy secure, convenient living near Lake Washington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "studio-apartments-downtown-kirkland-the-101",
      "search_query": "studio apartments downtown kirkland",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Downtown Kirkland",
      "h2_subtitle": "Explore studio apartments in downtown Kirkland at The 101. Enjoy modern living in a vibrant lakeside community with stunning amenities.",
      "page_copy": "At The 101, discover studio apartments in downtown Kirkland that cater to a modern urban lifestyle. Our chic studio homes combine stylish design with functionality, offering high-end finishes and conveniences tailored to your needs.\n\nLocated just steps from Lake Washington, enjoy the vibrant atmosphere of downtown Kirkland, complete with a rooftop deck showcasing stunning views and community conveniences like resident package lockers. Immerse yourself in the lakeside charm and dynamic neighborhood that make downtown Kirkland an unparalleled place to live. Choose The 101 for a well-rounded living experience in the heart of Kirkland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Downtown Kirkland",
      "seo_description": "Find studio apartments in downtown Kirkland at The 101. Experience modern living near Lake Washington with upscale amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-kirkland-wa-the-101",
      "search_query": "1 bedroom apartments kirkland wa",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Kirkland, WA",
      "h2_subtitle": "Discover 1 bedroom apartments in Kirkland, WA at The 101. Enjoy comfortable living in a vibrant community with top-tier amenities.",
      "page_copy": "Welcome to The 101, where our 1 bedroom apartments in Kirkland, WA offer the perfect blend of style and convenience. Each apartment features high-end finishes designed to elevate your living experience.\n\nResidents can unwind with breathtaking views from our rooftop deck or enjoy the close proximity to the Lake Washington waterfront, just two blocks away. Community amenities like resident package lockers and grill areas enhance daily life, making The 101 an ideal choice for those seeking a modern and relaxed lifestyle in downtown Kirkland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Kirkland, WA",
      "seo_description": "Explore 1 bedroom apartments in Kirkland, WA at The 101. Experience stylish living with modern amenities near Lake Washington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-near-moss-bay-the-101",
      "search_query": "2 bedroom apartments near moss bay",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Moss Bay",
      "h2_subtitle": "Find spacious 2 bedroom apartments near Moss Bay at The 101. Experience luxury living with impressive amenities.",
      "page_copy": "The 101 invites you to explore our luxurious 2 bedroom apartments near Moss Bay, designed with comfort and style in mind. These spacious homes are equipped with high-end finishes that elevate the living experience and provide a serene retreat in the heart of Kirkland.\n\nNestled just blocks from Lake Washington's sparkling waterfront, residents enjoy unparalleled access to stunning outdoor spaces. Take in the views from our rooftop deck, or relax with friends at our community grill areas. With convenient access to downtown and the vibrant Moss Bay community, The 101 is your gateway to elevated living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Moss Bay",
      "seo_description": "Discover luxury 2 bedroom apartments near Moss Bay at The 101. Enjoy stylish living with premium amenities near Lake Washington.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-near-university-of-washington-kirkland-the-101",
      "search_query": "apartments near university of washington kirkland",
      "category": "School",
      "h1_title": "Apartments Near University of Washington Kirkland",
      "h2_subtitle": "Discover stylish apartments near the University of Washington Kirkland at The 101. Enjoy convenience, comfort, and community in a prime location.",
      "page_copy": "The 101 offers exceptional apartments near the University of Washington Kirkland, perfect for both students and professionals. With a variety of floor plans, including studios and two-bedroom options, these apartments feature high-end finishes and modern amenities.\n\nResidents will appreciate the proximity to campus and the vibrant downtown Kirkland area, known for its lakeside charm. Enjoy the convenience of nearby dining and shopping options, along with our community's own rooftop deck with views of Lake Washington. The 101 is where comfort and convenience meet academic and social life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near University of Washington Kirkland",
      "seo_description": "Find apartments near the University of Washington Kirkland at The 101. Enjoy comfortable living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-close-to-university-of-washington-bothell-the-101",
      "search_query": "apartments close to university of washington bothell",
      "category": "School",
      "h1_title": "Apartments Close to University of Washington Bothell",
      "h2_subtitle": "Explore apartments close to University of Washington Bothell at The 101. Enjoy a vibrant community with modern amenities and convenient access.",
      "page_copy": "Discover the allure of living at The 101, offering beautifully-designed apartments close to University of Washington Bothell. These stylish residences provide a variety of floor plans, with studios and two-bedroom layouts that feature high-end finishes tailored for comfort and convenience.\n\nOur community is ideally situated in downtown Kirkland, bringing you closer to the excitement of the lakefront and the vibrancy of the city. Enjoy quick campus access while taking advantage of The 101's amenities, including a stunning rooftop deck and community-centered spaces perfect for studying or relaxing.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to University of Washington Bothell",
      "seo_description": "Discover apartments near University of Washington Bothell at The 101. Enjoy stylish living with convenient access and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "north-seattle-college-nearby-apartments-in-moss-bay-the-101",
      "search_query": "north seattle college nearby apartments in moss bay",
      "category": "School",
      "h1_title": "North Seattle College Nearby Apartments in Moss Bay",
      "h2_subtitle": "Located near North Seattle College, The 101 offers exceptional apartments in Moss Bay. Enjoy modern living in a prime location.",
      "page_copy": "Experience premium living at The 101, where North Seattle College nearby apartments in Moss Bay combine convenience with comfort. Our stylish studios and two-bedroom homes are perfect for students and professionals seeking a vibrant community close to college and city life.\n\nSituated just blocks from Lake Washington's scenic waterfront, The 101 provides residents with access to stunning outdoor spaces and urban attractions. Enjoy the rooftop deck's panoramic views or gather at our community grill areas. With easy access to both college and downtown Kirkland, The 101 offers the ideal balance of study and leisure.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "North Seattle College Nearby Apartments in Moss Bay",
      "seo_description": "Find apartments near North Seattle College in Moss Bay at The 101. Enjoy modern amenities and convenient access in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "the-quad-uw-king-county-nearby-apartments-the-101",
      "search_query": "the quad uw king county nearby apartments",
      "category": "School",
      "h1_title": "The Quad UW King County Nearby Apartments",
      "h2_subtitle": "Discover The 101, offering nearby apartments to The Quad UW in King County. Experience modern urban living with convenience and charm.",
      "page_copy": "Situated in Kirkland's vibrant Moss Bay neighborhood, The 101 offers nearby apartments to The Quad UW in King County, blending city life with lakeside leisure. Choose from beautifully designed studios and two-bedroom homes, complete with high-end finishes and contemporary amenities.\n\nOur community provides convenient access to university events and city attractions, all while offering spaces like a rooftop deck with stunning views of Lake Washington. Grills and fire pits invite social gatherings, making The 101 both a retreat and a jumping-off point to explore the nearby university and King County attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "The Quad UW King County Nearby Apartments",
      "seo_description": "Explore The 101 apartments near The Quad UW in King County. Enjoy modern living with easy access to university and city amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-near-seattle-childrens-hospital-kirkland-the-101",
      "search_query": "apartments near seattle children's hospital kirkland",
      "category": "Hospital",
      "h1_title": "Apartments Near Seattle Children's Hospital Kirkland",
      "h2_subtitle": "Find comfort and convenience at The 101, offering apartments near Seattle Children's Hospital in Kirkland. Enjoy stylish, modern living.",
      "page_copy": "Welcome to The 101, offering apartments near Seattle Children's Hospital in Kirkland, blending comfort with modern living. Our community provides easy access to healthcare facilities while ensuring a serene environment with amenities like a rooftop deck and fire pits.\n\nSelect from our range of stylish studios and two-bedroom apartments, each designed with high-end finishes and a contemporary flair. Situated just two blocks from Lake Washington, our location offers the perfect mix of urban convenience and natural beauty, making it an ideal choice for healthcare professionals and families alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Seattle Children's Hospital Kirkland",
      "seo_description": "Explore The 101, offering apartments near Seattle Children's Hospital in Kirkland. Enjoy comfortable living in a prime location with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "living-near-uw-medical-center-montlake-king-county-the-101",
      "search_query": "living near uw medical center montlake king county",
      "category": "Hospital",
      "h1_title": "Living Near UW Medical Center Montlake",
      "h2_subtitle": "Experience living near UW Medical Center Montlake at The 101 in King County. Discover modern comfort in a vibrant location.",
      "page_copy": "Embrace the convenience and charm of living near UW Medical Center Montlake from the comfort of The 101 in King County. Offering beautifully designed studios and two-bedroom apartments, our community provides a perfect blend of modern amenities and tranquil living, just a short commute away from Montlake.\n\nNestled in Kirkland's Moss Bay, The 101 offers residents easy access to both medical facilities and local attractions. Enjoy breathtaking views from our rooftop deck or relax by the grill and fire pits, all while being minutes from lakeside leisure and urban opportunities. The 101 ensures that your home supports both your professional and personal lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near UW Medical Center Montlake, King County",
      "seo_description": "Discover The 101, offering vibrant living near UW Medical Center Montlake in King County. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-near-marymoor-park-king-county-the-101",
      "search_query": "apartments near marymoor park king county",
      "category": "Park",
      "h1_title": "Apartments Near Marymoor Park King County",
      "h2_subtitle": "Explore The 101, offering apartments near Marymoor Park in King County. Enjoy modern living with access to nature and urban amenities.",
      "page_copy": "Welcome to The 101, offering beautifully designed apartments near Marymoor Park in King County, where urban living meets natural exploration. Choose from our range of spacious studios and two-bedroom homes, each featuring high-end finishes and a contemporary touch.\n\nLocated in the charming Moss Bay neighborhood of Kirkland, The 101 provides residents with easy access to both nature and city conveniences. With amenities such as a rooftop deck and resident package lockers, plus the serene backdrop of Lake Washington just blocks away, The 101 is the perfect place to enjoy the best of both worlds.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Marymoor Park, King County",
      "seo_description": "The 101 offers modern apartments near Marymoor Park in King County, combining city life with outdoor adventure. Discover stylish living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-close-to-warren-g-magnuson-park-kirkland-the-101",
      "search_query": "apartments close to warren g magnuson park kirkland",
      "category": "Park",
      "h1_title": "Apartments Close to Warren G Magnuson Park",
      "h2_subtitle": "Discover The 101, offering apartments close to Warren G Magnuson Park in Kirkland. Enjoy modern amenities and natural beauty.",
      "page_copy": "Find your next home at The 101, featuring stylish apartments close to Warren G Magnuson Park in Kirkland. Our community offers a harmonious balance of urban convenience and nature's delights, perfect for those who love outdoor activities.\n\nChoose from our modern studios and spacious two-bedroom layouts, which are thoughtfully designed with high-end finishes. Located in the vibrant Moss Bay area, The 101 provides residents with easy access to the park and the serene waterfront of Lake Washington, as well as amenities like a rooftop deck for enjoying stunning vistas. Experience the best of both worlds at The 101.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Warren G Magnuson Park",
      "seo_description": "Experience The 101 in Kirkland, offering modern living close to Warren G Magnuson Park. Enjoy urban comforts and lakeside tranquility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-near-bellevue-downtown-park-wa-the-101",
      "search_query": "apartments near bellevue downtown park wa",
      "category": "Park",
      "h1_title": "Apartments Near Bellevue Downtown Park",
      "h2_subtitle": "Explore The 101, offering apartments near Bellevue Downtown Park in WA. Experience modern living with prime amenities.",
      "page_copy": "Discover the elegance and convenience of living at The 101, offering apartments near Bellevue Downtown Park in WA. Our stylish community provides a perfect blend of urban sophistication and outdoor enjoyment, with easy access to the vibrant city life.\n\nChoose from luxurious studios and two-bedroom apartments, each boasting high-end finishes and contemporary amenities. Situated in the lively Moss Bay neighborhood of Kirkland, The 101 is just a short drive from the beauty of Bellevue Downtown Park and the vibrant attractions of the city, providing residents with stunning views and tranquil spaces right at home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bellevue Downtown Park, WA",
      "seo_description": "Find modern apartments at The 101, near Bellevue Downtown Park, WA. Enjoy sophisticated living close to urban and outdoor attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "living-near-washington-park-arboretum-seattle-the-101",
      "search_query": "living near washington park arboretum seattle",
      "category": "Park",
      "h1_title": "Living Near Washington Park Arboretum",
      "h2_subtitle": "Discover The 101 for living near Washington Park Arboretum, Seattle. Enjoy a modern, relaxed lifestyle with scenic surroundings.",
      "page_copy": "Experience the unique lifestyle at The 101, ideal for those who seek living near Washington Park Arboretum in Seattle. Situated in the vibrant Moss Bay area of Kirkland, our community offers the perfect blend of urban comfort and natural serenity.\n\nOur selection of studios and two-bedroom apartments come with high-end finishes and amenities that enhance your living experience, such as lake-view rooftop decks and proximity to downtown conveniences. Whether you're drawn to the scenic trails of the arboretum or the bustling life of the city, The 101 places you near Seattle's vibrant attractions while providing a peaceful retreat.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Washington Park Arboretum, Seattle",
      "seo_description": "Live at The 101 near Washington Park Arboretum, Seattle, and enjoy a blend of urban amenities and natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-close-to-green-lake-park-moss-bay-the-101",
      "search_query": "apartments close to green lake park moss bay",
      "category": "Park",
      "h1_title": "Apartments Close to Green Lake Park",
      "h2_subtitle": "Explore The 101, featuring apartments close to Green Lake Park in Moss Bay. Enjoy vibrant living amidst nature's beauty.",
      "page_copy": "Welcome to The 101, where you can find exquisite apartments close to Green Lake Park in the charming Moss Bay neighborhood. Our community provides a serene setting with urban amenities, perfect for nature lovers and city dwellers alike.\n\nChoose from beautifully designed studios and two-bedroom apartments, each featuring high-end finishes. Located just minutes from the idyllic Green Lake Park, The 101 ensures easy access to outdoor activities, while also offering residents a rooftop deck with breathtaking views of Lake Washington and Seattle's skyline. Experience the best of both worlds at The 101.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Green Lake Park, Moss Bay",
      "seo_description": "Live at The 101, offering stylish apartments near Green Lake Park, Moss Bay. Enjoy a balanced lifestyle with urban and natural amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "apartments-close-to-u-district-kirkland-the-101",
      "search_query": "apartments close to U District Kirkland",
      "category": "Transit",
      "h1_title": "Apartments Close to U District Kirkland",
      "h2_subtitle": "Discover The 101, offering apartments close to the U District in Kirkland. Experience modern living with excellent connectivity.",
      "page_copy": "The 101 is your gateway to vibrant living, located close to the U District in Kirkland. Our community offers an ideal mix of urban luxury and accessibility, perfect for those wanting quick access to university life without compromising on comfort.\n\nOffering a range of studios and two-bedroom apartments, The 101 features sleek, high-end finishes and modern amenities. Situated in the lively Moss Bay neighborhood, you'll enjoy a short commute to the U District while relishing the stunning vistas from our rooftop deck overlooking Lake Washington. Make The 101 your home for a balanced lifestyle in Kirkland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to U District, Kirkland",
      "seo_description": "Find modern apartments at The 101, close to the U District in Kirkland. Enjoy urban luxury and speedy access to university life.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "living-near-university-of-washington-station-the-101",
      "search_query": "living near University of Washington Station",
      "category": "Transit",
      "h1_title": "Living Near University of Washington Station",
      "h2_subtitle": "The 101 offers living near University of Washington Station. Enjoy seamless transit access and modern conveniences in Kirkland.",
      "page_copy": "Discover the perfect blend of connectivity and comfort at The 101, ideal for those who seek living near University of Washington Station. Located in the vibrant Moss Bay area of Kirkland, our community provides convenient access to transit while ensuring a peaceful residential experience.\n\nOur selection of studios and spacious two-bedroom apartments feature luxurious finishes and modern amenities. Enjoy the best of both worlds with The 101's proximity to the bustling University District and tranquil views from our rooftop deck overlooking Lake Washington. Whether commuting or unwinding, The 101 is your ideal home base.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near University of Washington Station",
      "seo_description": "Experience urban living at The 101, near University of Washington Station, with modern comforts and easy transit access in Kirkland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "kirkland-properties-near-roosevelt-transit-the-101",
      "search_query": "Kirkland properties near Roosevelt transit",
      "category": "Transit",
      "h1_title": "Kirkland Properties Near Roosevelt Transit",
      "h2_subtitle": "Explore The 101, featuring Kirkland properties near Roosevelt transit. Enjoy urban living with effortless connectivity.",
      "page_copy": "Situated in the bustling neighborhood of Moss Bay, The 101 offers prime Kirkland properties near Roosevelt transit. Our community embodies the spirit of city living with seamless access to transit options, making your daily commute a breeze.\n\nChoose from a variety of studio and two-bedroom layouts, all designed with high-end finishes and modern amenities. Enjoy the convenience of being close to transit hubs while relishing in breathtaking views from our rooftop deck overlooking Lake Washington and the Seattle skyline. At The 101, experience urban sophistication balanced with excellent connectivity.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Kirkland Properties Near Roosevelt Transit",
      "seo_description": "Discover The 101, offering properties in Kirkland near Roosevelt transit. Enjoy urban sophistication and easy connectivity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "king-county-apartments-near-northgate-the-101",
      "search_query": "King County apartments near Northgate",
      "category": "Transit",
      "h1_title": "King County Apartments Near Northgate",
      "h2_subtitle": "Find The 101, King County apartments near Northgate. Experience refined living with great connectivity in Kirkland.",
      "page_copy": "Nestled in Kirkland's vibrant Moss Bay, The 101 offers premier King County apartments near Northgate. Perfectly positioned for those who value easy access to transit, our community ensures you stay connected while enjoying the tranquility of lakeside living.\n\nChoose from our selection of studio and two-bedroom apartments, each designed with modern elegance and high-end finishes. While Northgate is just a short trip away, residents can also enjoy the sweeping views of Lake Washington and the Seattle skyline from our rooftop deck. The 101 is where connectivity meets comfort, offering a lifestyle that suits both professionals and students alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "King County Apartments Near Northgate",
      "seo_description": "Explore The 101, offering King County apartments near Northgate with modern living and easy access in Kirkland.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162415",
      "property_id": "6767906449164270",
      "source": "custom",
      "page_item_url": "moss-bay-living-bellevue-downtown-transit-the-101",
      "search_query": "Moss Bay living with access to Bellevue Downtown transit",
      "category": "Transit",
      "h1_title": "Moss Bay Living with Bellevue Transit Access",
      "h2_subtitle": "Discover Moss Bay living with Bellevue Downtown transit access at The 101, combining urban appeal with convenience.",
      "page_copy": "Experience the best of Moss Bay living with access to Bellevue Downtown transit at The 101. Our community melds the charm of lakeside views with the convenience of urban connectivity, making commuting simple and hassle-free.\n\nAt The 101, choose from our sophisticated studios and generous two-bedroom apartments, crafted with contemporary finishes. Located a stone's throw from the beautiful Lake Washington waterfront, you'll enjoy both relaxation and easy transit access to Bellevue Downtown. Embrace the ideal balance of work and leisure at The 101, where everything you need is right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of the building facade with brick and modern paneling, balconies, and large windows.",
        "public_id": "019d0814-1ff7-774f-87f8-783d5c62667a",
        "storage_key": "property/6767906449164270/019d0814-1ff7-774f-87f8-783d5c62667a.webp",
        "width": 998,
        "height": 665
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Moss Bay Living with Bellevue Transit Access",
      "seo_description": "The 101 offers Moss Bay living with Bellevue Downtown transit access, combining lakeside charm and urban convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4933"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9241077911"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-P5QHNK6S"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/aaeb50ee-924a-4386-81f5-274b83a81fa1/app.js?property=aaeb50ee-924a-4386-81f5-274b83a81fa1&propertyName=The 101&channelUuid=c0a15f1b-7c1c-11eb-8904-42010aa8d42b\" defer></script>"
    },
    {
      "ID": "custom_engrain_sitemap_id",
      "type": "STRING",
      "value": "05eve61xpqo"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/05eve61xpqo"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "857-290-5839"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkpMNHZaS0Fybis3dy9TeE9BN0xLdUE9PSIsInZhbHVlIjoiVURJZGFPZzcwS25IWU94VUVEU3hrUT09IiwibWFjIjoiZGIwZmVmNzY1MWY0NzI2NzBmYzI4YmIxYTVmZjEyMTVmY2RlZDQ3OTRhMGJkZjcwZWRlYzg1NzYyY2QyOTc5YyJ9"
    },
    {
      "ID": "custom_pillar_properties_guarantee",
      "type": "STRING",
      "value": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple."
    },
    {
      "ID": "custom_pillar_properties_screening_criteria",
      "type": "STRING",
      "value": "https://multihubmedia.com/company/5767906449162415/019db50d-a878-72d8-8525-3b5177277f86.pdf"
    },
    {
      "ID": "custom_pillar_properties_guarantee_disclaimer",
      "type": "STRING",
      "value": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
    }
  ],
  "custom_qb_id": "4933",
  "custom_repli_id": "9241077911",
  "custom_google_gtm_id": "GTM-P5QHNK6S",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/aaeb50ee-924a-4386-81f5-274b83a81fa1/app.js?property=aaeb50ee-924a-4386-81f5-274b83a81fa1&propertyName=The 101&channelUuid=c0a15f1b-7c1c-11eb-8904-42010aa8d42b\" defer></script>",
  "custom_engrain_sitemap_id": "05eve61xpqo",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/05eve61xpqo",
  "custom_ppc_tracking_phone_number": "857-290-5839",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkpMNHZaS0Fybis3dy9TeE9BN0xLdUE9PSIsInZhbHVlIjoiVURJZGFPZzcwS25IWU94VUVEU3hrUT09IiwibWFjIjoiZGIwZmVmNzY1MWY0NzI2NzBmYzI4YmIxYTVmZjEyMTVmY2RlZDQ3OTRhMGJkZjcwZWRlYzg1NzYyY2QyOTc5YyJ9",
  "custom_pillar_properties_guarantee": "Who says there are no guarantees in life?     At Pillar Properties, we care and it shows. As a family-owned company with roots in the Puget Sound region spanning five generations, we do things our way. That means we are focused on delivering an ideal resident experience as measured by our own exacting standards.     Our team works diligently to ensure that the experience at our properties aligns with residents’ lifestyles, needs, and expectations. Resident satisfaction drives everything we do. We know that feeling supported is one of the most important hallmarks of home and that is why we offer our Quietly Awesome Guarantee.     We are so confident that you will love your new Pillar Properties apartment that we will waive the early termination penalties as defined in your lease if you are not satisfied and decide to leave within the first thirty days. It’s just that simple.",
  "custom_pillar_properties_screening_criteria": "https://multihubmedia.com/company/5767906449162415/019db50d-a878-72d8-8525-3b5177277f86.pdf",
  "custom_pillar_properties_guarantee_disclaimer": "·  Guarantee applies to the first 30 days of occupancy only  ·  Notify the Property Manager in writing if you decide to move  ·  Any extra days will be charged if the apartment is not vacated after the initial 30 days"
};

export const generatedAt = '2026-09-29T17:36:34.289Z';
